import { CARGO_TYPE, DESCRIPTION_SEPARATOR, TCargoRow } from '@types';
import { getBookedShipmentCargoTypeLabel } from './getBookedShipmentCargoTypeLabel';
import { getCargoTypeListLabel } from './getCargoTypeListLabel';
import { getCargoQuantitySegments } from './getCargoQuantitySegments';

/* "LTL, Bundle/Pallet, 4 Qty, 4 Spaces, 10.00 m³, 200 kg" - a Pallets/Bundle/Skid/Other shipment's cargo line for
   the shipment details title-summary and the list tables' Cargo column. cargoType leads with its capacity label
   ("LTL"); tables that show capacity in a column of their own (Labels, Partial Bookings) leave it out and pass
   DESCRIPTION_SEPARATOR.PIPE - "Bundle/Pallet | 4 Qty | ...". Every other capacity type keeps using
   getCargoTransportDescription / getCargoFullDescription. */
export const getMixedCargoTransportDescription = (
	rows: TCargoRow[],
	options: { cargoType?: CARGO_TYPE; separator?: DESCRIPTION_SEPARATOR } = {}
): string => {
	const { cargoType, separator = DESCRIPTION_SEPARATOR.COMMA } = options;
	return [
		cargoType ? getBookedShipmentCargoTypeLabel(cargoType) : '',
		getCargoTypeListLabel(rows),
		...getCargoQuantitySegments(rows)
	].filter(Boolean).join(separator);
};
